import {useContext, useEffect, useRef, useState} from 'react';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from '@core/scripts/components/messages';
import Navigation from './navigation-small/Navigation.jsx';
import {MobileNavigationContextProvider} from '../context/mobile-navigation-context.jsx';
import {NAVIGATION_ACCORDION_CLOSE_DELAY} from './constants.js';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';

export default function NavigationSmall({currentShopId, currentPage, headerRef}) {
    const {mobileNaviOpened} = useContext(HeaderContext);

    const [visible, setVisible] = useState(mobileNaviOpened);
    const mobileNaviContainer = useRef();

    useEffect(() => {
        const messages = [MessageBroker.subscribe(Messages.APP_BANNER.CLOSE, moveContainerBelowHeader)];

        return () => {
            messages.forEach((message) => MessageBroker.unsubscribe(message));
        };
    }, []);

    useEffect(() => {
        if (!mobileNaviOpened) {
            setTimeout(() => setVisible(false), NAVIGATION_ACCORDION_CLOSE_DELAY);
        } else {
            setVisible(true);
        }
    }, [mobileNaviOpened]);

    const moveContainerBelowHeader = () => {
        const headerBottom = headerRef.current.getBoundingClientRect().bottom;
        mobileNaviContainer.current.style.top = `${headerBottom}px`;
    };

    const moveContainerToTop = () => {
        mobileNaviContainer.current.style.top = '0';
    };

    return (
        <div ref={mobileNaviContainer} className={`navigation__mobile-container${mobileNaviOpened ? ' -open' : ''}`}>
            <MobileNavigationContextProvider currentShopId={currentShopId} currentPage={currentPage}>
                {visible && (
                    <Navigation
                        moveContainerBelowHeader={moveContainerBelowHeader}
                        moveContainerToTop={moveContainerToTop}
                    />
                )}
            </MobileNavigationContextProvider>
        </div>
    );
}
